import { KestrelViewerMessageCallbackAPI } from 'features/kestrelViewer'
import { KVUserSettings, KVUserSettingsJSON } from 'types'

import { KVMessageDef } from './index'

export function getSettingsUpdatedMessage() {
  return {
    type: 'settingsUpdated',
    requiredData: ['settings'],

    callback: (
      json: Record<string, unknown>,
      kv: KestrelViewerMessageCallbackAPI
    ) => {
      const settings = KVUserSettings.fromJSON(
        json.settings as KVUserSettingsJSON
      )
      if (kv.setSettings) {
        kv.setSettings(settings)
      }
    },
  } as KVMessageDef
}
